/**
 * Open banking (Enable Banking): indirizzo di ritorno dalla banca e pagina da cui era partito
 * il collegamento. La pagina di ritorno è /auth/banca su ogni dominio dell'app: ogni dominio va
 * registrato tra i Redirect URLs dell'applicazione Enable Banking.
 */
export const BANK_LINK_PATH = "/auth/banca";
export const BANK_LINK_RETURN_KEY = "ml_bank_link_return";

export function bankLinkRedirectUrl(): string {
  return `${window.location.origin}${BANK_LINK_PATH}`;
}
